/**
 * 売上品目単価
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/sales_item_prices`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      reference_date: null,
      code: null,
      name: null,
      item_id: null,
      sales_item_type: null,
    },
  }
}

const sales_item_price = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 売上品目単価 一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param reference_date
     * @param code
     * @param name
     * @param item_id
     * @param sales_item_type
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { reference_date, code, name, item_id, sales_item_type, page, limit }) {

      dispatch('saveCondition', { reference_date: reference_date, code: code, name: name, item_id: item_id, sales_item_type: sales_item_type,limit: limit})
      const params = {
        reference_date: state.condition.reference_date,
        code: state.condition.code,
        name: state.condition.name,
        item_id: state.condition.item_id,
        sales_item_type: state.condition.sales_item_type,
        page: page,
        limit: state.condition.limit,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_SALES_ITEM_PRICE_PAGINATION, { content })
          resolve(content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { limit, reference_date, code, name, item_id, sales_item_type }) {
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const _reference_date = (reference_date !== undefined) ? reference_date : state.condition.reference_date
      const _code = (code !== undefined) ? code : state.condition.code
      const _name = (name !== undefined) ? name : state.condition.name
      const _item_id = (name !== undefined) ? item_id : state.condition.item_id
      const _sales_item_type = (name !== undefined) ? sales_item_type : state.condition.sales_item_type
      const params = {
        limit: _limit,
        reference_date: _reference_date,
        code: _code,
        name: _name,
        item_id: _item_id,
        sales_item_type: _sales_item_type
      }
      commit(types.DRIVER_SALES_ITEM_PRICE_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_SALES_ITEM_PRICE_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_SALES_ITEM_PRICE_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_SALES_ITEM_PRICE_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_SALES_ITEM_PRICE_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_SALES_ITEM_PRICE_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_SALES_ITEM_PRICE_CONDITION] (state, { params }) {
      state.condition.limit = params.limit
      state.condition.reference_date = params.reference_date
      state.condition.code = params.code
      state.condition.name = params.name
      state.condition.item_id = params.item_id
      state.condition.sales_item_type = params.sales_item_type
    }

  },
}

export default sales_item_price
